import React, {useState, useEffect} from 'react'

// Bootstrap Components
import { Row, Col, Card, CardImg, CardBody, CardHeader, CardTitle, CardText, CardFooter, Button } from 'react-bootstrap'

// Context
import { PortfolioContext } from '../../../context/PortfolioContext.js'

// React Router
import { Link } from 'react-router';

// CSS
import "./index.css"

export default function PortfolioList() {

        const { portfolioList } = PortfolioContext();
        const sortedList = [...portfolioList].filter(portfolio => portfolio.portfolio_active).sort(
            (a, b) => b.date_added.seconds - a.date_added.seconds
        );
    
    
      if (!portfolioList || !sortedList) {
        return <h1>Loading</h1>;
      }

  return (
<Row className='portfolioList' align='center'>
      {sortedList.map((portfolio) => {
        return (
          <Col xs={12} md={6} lg={4}>
            <Card style={{border: 'none', height: "100%", maxWidth: "25rem"}}>
                {portfolio.portfolio_cover_image ? 
                <>
                    <CardImg src={portfolio.portfolio_cover_image} className='cardImage' />
                </> 
                : 
                <></>
                }
                    
                        <CardBody>
                            <CardHeader>
                                <CardTitle>{portfolio.portfolio_name}</CardTitle>
                            </CardHeader>
                            <CardText>
                            {portfolio.portfolio_description.slice(0, 100)}...
                            </CardText>
                            <CardFooter>
                                <Link to={`/portfolios/${portfolio.portfolio_id}`}><Button>View Portfolio</Button></Link>
                            </CardFooter>
                        </CardBody>
                    </Card>
          </Col>
        );
      })}
    </Row>
  )
}
